import Layout from '../../layout/index'

const seniorClassRouter = {
  path: '/seniorclass',
  component: Layout,
  redirect: '/seniorclass/index',
  children: [
    {
      path: 'index',
      name: 'seniorClass',
      component: () => import('../../views/seniorclass/index')
    },
    {
      path: 'detail',
      name: 'seniorClassDetail',
      component: () => import('../../views/seniorclass/detail')
    }
  ]
}
export default seniorClassRouter
